import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid'
import nlLocale from '@fullcalendar/core/locales/nl';


document.addEventListener('DOMContentLoaded', function () {

    if (!document.getElementById('order-view')) return;
    const calendarEl = document.getElementById('calendar');

    if (calendarEl === null) {
        return;
    }
    const slotMinTime = '07:00:00';
    const slotMaxTime = '19:00:00';
    let modal = document.getElementById('event-modal');
    modal = new bootstrap.Modal(modal, {
        keyboard: false
    });
    let calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: 'timeGridWeek',
        locale: nlLocale,
        firstDay: 1,
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay refresh'
        },
        views: {
            timeGridDay: {
                slotMinTime: slotMinTime,
                slotMaxTime: slotMaxTime
            },
            timeGridWeek: {
                slotMinTime: slotMinTime,
                slotMaxTime: slotMaxTime
            }
        },
        customButtons: {
            refresh: {
                text: 'Refresh',
                click: function () {
                    calendar.refetchEvents();
                }
            }
        },

        datesSet: function (info) {
            getEvents(info);
        },

        eventClick: function (info) {
            modal.show();

            jQuery(function ($) {

                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: {
                        action: 'get_order_details',
                        order_id: info.event.id
                    },
                    success: function (response) {
                        $('#event-modal-content').html(response);
                    }
                })
            });
        },
    });

    calendar.render();

    function getEvents(data) {
        calendar.getEvents().forEach(function (event) {
            event.remove();
        });
        var startDate = data.start.toISOString();
        var endDate = data.end.toISOString();
        if (data.view.type == 'timeGridDay') {
            startDate = formatDateToLocalISO(data.start);
            endDate = startDate;

        }

        jQuery(function ($) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'get_events',
                    start_date: startDate,
                    end_date: endDate
                },
                success: function (response) {
                    response = JSON.parse(response);

                    if (response.success == true) {
                        var events = response.events;
                        for (var i = 0; i < events.length; i++) {
                            calendar.addEvent({
                                ...events[i],
                                allDay: false,
                            });
                        }
                        calendar.refetchEvents();
                    }
                }
            });
        });
    }
    function formatDateToLocalISO(date) {
        var tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
        var localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
        return localISOTime;
    }
});